import { Vue, Component, namespace } from 'nuxt-property-decorator'
import { IMeta } from '~/assets/interfaces/meta'

const pageStore = namespace('page')

@Component({})
export default class MixinPage extends Vue {
  @pageStore.Mutation('setMeta') public setMeta!: (meta: IMeta) => void

  public meta: IMeta | null = null

  public initMeta() {
    if (this.meta) {
      this.setMeta(this.meta)
    }
  }
}
